/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Tit2Tremor } from "../comps/coolComp";
import {
  RColumn,
  RGrid,
  RRow,
  Space,
  SpaceHorizontal,
} from "../comps/otherCOmps";
import {
  AreaChart,
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeaderCell,
  TableRow,
} from "@tremor/react";
import { getBestGamesChatGames, getStatsChatGames } from "./dao";
import { formatNumberInStr, getPriceToken } from "../util/util";
import { RiCircleFill, RiCircleLine } from "@remixicon/react";

export default function ChatGames() {
  const [statsGames, setStatsGames] = useState();
  const [bestGames, setBestGames] = useState([]);
  const [showInGraphs, setShowInGraphs] = useState({});

  const chartIds = ["24h", "7d"];
  const [currRate, setCurrRate] = useState({});
  const currs = ["eth", "sol", "ton", "usdt", "usdc", "ghub"];

  useEffect(() => {
    getStatsChatGames().then((p) => setStatsGames(p));
    getBestGamesChatGames().then((p) => setBestGames(p));
    currs.forEach((c) => {
      getPriceToken(c).then((p) => setCurrRate((pr) => ({ ...pr, [c]: p })));
    });
    let newShowInG = {};
    chartIds.forEach((id) => {
      newShowInG[id] = ["totalbets", "totalprofit", "totalvolume"];
    });
    setShowInGraphs(newShowInG);
  }, []);

  if (!statsGames) {
    return <>loading</>;
  }

  function ChartShowCat({ children, chartId, field }) {
    const isSelected = (showInGraphs[chartId] ?? []).includes(field);
    return (
      <Card
        className="px-2 py-1 text-tremor-label w-32 cursor-pointer"
        style={{
          border: isSelected ? "1px solid blue" : undefined,
        }}
        onClick={() =>
          setShowInGraphs((p) => {
            const currentFields = p[chartId] ?? [];
            return {
              ...p,
              [chartId]: currentFields.includes(field)
                ? currentFields.filter((f) => f !== field) // Rimuove il field se esiste
                : [...currentFields, field], // Aggiunge il field se non esiste
            };
          })
        }
      >
        <RRow>
          {!isSelected && <RiCircleLine color="lightblue" size={18} />}
          {isSelected && <RiCircleFill color="lightblue" size={18} />}
          <SpaceHorizontal width="6px" />
          {children}
        </RRow>
      </Card>
    );
  }

  return (
    <>
      <Tit2Tremor>chatgames</Tit2Tremor>
      <Space />

      <RGrid>
        <Card className="w-52 mx-2 my-2">
          <dt className="text-tremor-default font-medium text-tremor-content dark:text-dark-tremor-content">
            Total bets
          </dt>
          <dd className="mt-2 flex items-baseline space-x-2.5">
            <span className="text-tremor-metric font-semibold text-tremor-content-strong dark:text-dark-tremor-content-strong">
              {formatNumberInStr(parseInt(statsGames.totalbets))}
            </span>
          </dd>
        </Card>
        <Card className="w-56 mx-2 my-2">
          <dt className="text-tremor-default font-medium text-tremor-content dark:text-dark-tremor-content">
            Total volume
          </dt>
          <dd className="mt-2 flex items-baseline space-x-2.5">
            <span className="text-tremor-metric font-semibold text-tremor-content-strong dark:text-dark-tremor-content-strong">
              {formatNumberInStr(statsGames.totalvolume)}
            </span>
          </dd>
        </Card>
        <Card className="w-56 mx-2 my-2">
          <dt className="text-tremor-default font-medium text-tremor-content dark:text-dark-tremor-content">
            Total profit
          </dt>
          <dd className="mt-2 flex items-baseline space-x-2.5">
            <span className="text-tremor-metric font-semibold text-tremor-content-strong dark:text-dark-tremor-content-strong">
              {formatNumberInStr(parseFloat(statsGames.totalprofit))}
            </span>
          </dd>
        </Card>
        <Card className="w-60 mx-2 my-2 p-5">
          <dt className="text-tremor-default font-medium text-tremor-content dark:text-dark-tremor-content">
            Last 24h
          </dt>
          <Space height="4px" />
          <RRow>
            <RColumn horizontalAlign="start">
              <dt className="text-tremor-title font-bold text-tremor-content-strong dark:text-dark-tremor-content">
                {formatNumberInStr(statsGames.last24Hours?.totalbets)}
              </dt>
              <dt className="text-tremor-default font-medium text-tremor-content dark:text-dark-tremor-content">
                bets
              </dt>
            </RColumn>
            <SpaceHorizontal width="22px" />
            <RColumn horizontalAlign="start">
              <dt className="text-tremor-title font-bold text-tremor-content-strong dark:text-dark-tremor-content">
                {formatNumberInStr(
                  parseFloat(statsGames.last24Hours?.totalvolume)
                )}
              </dt>
              <dt className="text-tremor-default font-medium text-tremor-content dark:text-dark-tremor-content">
                volume
              </dt>
            </RColumn>
            <SpaceHorizontal width="22px" />
            <RColumn horizontalAlign="start">
              <dt className="text-tremor-title font-bold text-tremor-content-strong dark:text-dark-tremor-content">
                {formatNumberInStr(
                  parseFloat(statsGames.last24Hours?.totalprofit)
                )}
              </dt>
              <dt className="text-tremor-default font-medium text-tremor-content dark:text-dark-tremor-content">
                profit
              </dt>
            </RColumn>
          </RRow>
        </Card>
      </RGrid>
      <div className="flex flex-row gap-x-2 mt-5 items-end">
        <Tit2Tremor>Last 24 hours</Tit2Tremor>
        <SpaceHorizontal />
        <ChartShowCat chartId={chartIds[0]} field="totalvolume">
          Volume
        </ChartShowCat>

        <ChartShowCat chartId={chartIds[0]} field="totalprofit">
          Profit
        </ChartShowCat>

        <ChartShowCat chartId={chartIds[0]} field="totalbets">
          Num bets
        </ChartShowCat>
      </div>
      <AreaChart
        data={statsGames.hourlyStats ?? []}
        index="hour"
        categories={showInGraphs[chartIds[0]]}
        colors={["blue", "violet", "red"]}
        valueFormatter={formatNumberInStr}
        showLegend={false}
        showYAxis={true}
        showGradient={true}
        startEndOnly={true}
        className="mt-6 h-60"
      />
      <div className="flex flex-row gap-x-2 mt-5 items-end">
        <Tit2Tremor>Last 7 days</Tit2Tremor>
        <SpaceHorizontal />
        <ChartShowCat chartId={chartIds[1]} field="totalvolume">
          Volume
        </ChartShowCat>

        <ChartShowCat chartId={chartIds[1]} field="totalprofit">
          Profit
        </ChartShowCat>

        <ChartShowCat chartId={chartIds[1]} field="totalbets">
          Num bets
        </ChartShowCat>
      </div>
      <AreaChart
        data={statsGames.dailyStats ?? []}
        index="day"
        categories={showInGraphs[chartIds[1]]}
        colors={["blue", "violet", "red"]}
        valueFormatter={formatNumberInStr}
        showLegend={false}
        showYAxis={true}
        showGradient={true}
        startEndOnly={true}
        className="mt-6 h-60"
      />
      <Space />
      <RGrid>
        <Space />
        {bestGames.map((g) => (
          <Card
            key={g.gameType}
            className="mb-3 mx-1"
            style={{ width: "100%" }}
          >
            <Tit2Tremor>{g.gameType}</Tit2Tremor>
            <Table>
              <TableHead>
                <TableRow className="border-b border-tremor-border dark:border-dark-tremor-border">
                  <TableHeaderCell className="text-tremor-content-strong dark:text-dark-tremor-content-strong">
                    Curr
                  </TableHeaderCell>
                  <TableHeaderCell className="text-tremor-content-strong dark:text-dark-tremor-content-strong">
                    bets
                  </TableHeaderCell>
                  <TableHeaderCell className="text-tremor-content-strong dark:text-dark-tremor-content-strong">
                    bets amt
                  </TableHeaderCell>
                  <TableHeaderCell className="text-tremor-content-strong dark:text-dark-tremor-content-strong">
                    losses
                  </TableHeaderCell>
                  <TableHeaderCell className="text-tremor-content-strong dark:text-dark-tremor-content-strong">
                    losses amt
                  </TableHeaderCell>
                  <TableHeaderCell className="text-tremor-content-strong dark:text-dark-tremor-content-strong">
                    wins
                  </TableHeaderCell>
                  <TableHeaderCell className="text-tremor-content-strong dark:text-dark-tremor-content-strong">
                    wins amt
                  </TableHeaderCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {g.currency.map((curr) => (
                  <TableRow key={curr.currency + g.gameType}>
                    <TableCell>{curr.currency}</TableCell>
                    <TableCell>{curr.totalbets}</TableCell>
                    <TableCell>
                      {formatNumberInStr(
                        curr.total_bets_amount * currRate[curr.currency] ?? 0
                      )}
                    </TableCell>
                    <TableCell>{curr.total_losses}</TableCell>
                    <TableCell>
                      {formatNumberInStr(
                        curr.total_losses_amount * currRate[curr.currency] ?? 0
                      )}
                    </TableCell>
                    <TableCell>{curr.total_wins}</TableCell>
                    <TableCell>
                      {formatNumberInStr(
                        curr.total_wins_amount * currRate[curr.currency] ?? 0
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Card>
        ))}
      </RGrid>
    </>
  );
}
